import { useNavigate } from "react-router-dom";

const GoogleBook = ({ googleBook }) => {
  const navigate = useNavigate();

  return (
    <div
      className="card p-4 cursor-pointer hover:border-teal-600 max-w-md"
      onClick={() => navigate("/books/new", { state: { googleBook } })}
    >
      {googleBook.thumbnailUrl && (
        <img
          src={googleBook.thumbnailUrl}
          alt={googleBook.title}
          className="h-20 mb-2"
        />
      )}
      <div className="font-medium text-stone-800">{googleBook.title}</div>
      <div className="text-sm text-stone-500 break-words">
        {googleBook.authors?.join(", ")}
      </div>
      {googleBook.isbn13 && (
        <div className="text-xs text-stone-400 mt-1">
          ISBN-13: {googleBook.isbn13}
        </div>
      )}
    </div>
  );
};

export default GoogleBook;
